module.exports = __webpack_public_path__ + "static/media/home-page-header-xl.f08c26ce.jpg";